/* unplugin-vue-components disabled */import script from "./NewsCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsCard.vue?vue&type=script&lang=ts&setup=true"

import "./NewsCard.vue?vue&type=style&index=0&id=613fae53&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-613fae53"]])

export default __exports__